<template>
  <v-card>
    <div class="pa-2 px-4">
      <div class="d-flex align-center">
        <img class="company-logo" src="@/assets/LyricsterLogo.png" />
      </div>
      <h5 class="ml-2 text-center mt-3">
        Lyricster Public Benefit Corporation.<br />All Rights Reserved. 2021.
      </h5>
      <ul class="d-flex links mt-3">
        <li>
          <a href="http://www.lyricster.io" target="_blank">About Us</a>
        </li>
        <li>
          <a href="http://www.lyricster.io/help-center" target="_blank"
            >Help Center</a
          >
        </li>
        <li>
          <a href="http://www.lyricster.io/matching-app" target="_blank"
            >Download our Matching App</a
          >
        </li>
        <li>
          <a href="mailto:support@lyricster.io" target="_blank"
            >Email the Team</a
          >
        </li>
        <li>
          <a href="https://www.lyricster.io/invest" target="_blank">Invest</a>
        </li>
        <li>
          <a href="https://www.lyricster.io/legal" target="_blank">Legal</a>
        </li>
      </ul>
      <div class="d-flex align-center justify-center mt-4">
        <a
          href="https://www.facebook.com/"
          target="_blank"
          class="social facebook"
        >
          <i class="fa fa-facebook"></i>
        </a>
        <a
          href="https://www.instagram.com/lyricster.io/"
          target="_blank"
          class="social instagram"
        >
          <i class="fa fa-instagram"></i>
        </a>
        <a
          href="https://www.youtube.com/channel/UCMntV5oBZPvu-1KxdugcA3w"
          target="_blank"
          class="social youtube"
        >
          <i class="fa fa-youtube"></i>
        </a>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "info",
};
</script>

<style scoped>
.social {
  width: 35px;
  height: 35px;
  color: #fff;
  text-decoration: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
}
.facebook {
  background: #1877f2;
}
.instagram {
  background: #e4405f;
}
.youtube {
  background: #cd201f;
}
.company-logo {
  width: 80px;
  margin: 0 auto;
}
.links {
  flex-wrap: wrap;
  /* list-style-type: none; */
  justify-content: center;
}
.links li {
  margin-right: 25px;
  font-size: 12px;
}
.links li a {
  color: rgba(0, 0, 0, 0.8);
}
</style>
